if (!customElements.get('cart-addons')) {
  customElements.define(
    'cart-addons',
    class CartAddons extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-addon-select]');
          if (!select) return;
          const button = select.closest('.cart-addons__item').querySelector('[data-addon-add]');
          if (button) button.dataset.variantId = select.value;
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-addon-add]');
          if (button) this.add(button);
        });
      }

      async add(button) {
        const drawer = document.querySelector('cart-drawer');
        const error = this.querySelector('.cart-addons__error');
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        if (error) error.hidden = true;
        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || state.message || '');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(state);
          } else {
            window.location.reload();
          }
          // Let other cart listeners (e.g. the Bundle & Save bar) refresh their counts.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-addons',
              productVariantId: Number(button.dataset.variantId),
              cartData: state,
            });
          }
        } catch (e) {
          if (error) {
            error.textContent = e.message || window.cartStrings?.error || 'Something went wrong.';
            error.hidden = false;
          }
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      }
    }
  );
}
